// @ts-check
/**
 * Category chips on the product grid. On the All products collection (every
 * product on one page) chips filter instantly and update the URL to the
 * collection's own address, so a reload or shared link shows the same list.
 * Elsewhere chips are plain links. Mirrors the shop filters in app.ts.
 */
import { $, $$, config, tpl } from '@theme/theme';

class CollectionGrid extends HTMLElement {
  connectedCallback() {
    if (!this.hasAttribute('data-client')) return;
    const bar = $('[data-filters]', this);
    if (!bar) return;
    this.allUrl = location.pathname;
    bar.addEventListener('click', (e) => {
      const chip = /** @type {HTMLAnchorElement | null} */ (/** @type {HTMLElement} */ (e.target).closest('[data-filter]'));
      if (!chip || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      const cat = /** @type {string} */ (chip.dataset.filter);
      history.replaceState(null, '', cat === 'all' ? this.allUrl : chip.pathname);
      this.apply(cat);
    });
  }

  /** @param {string} cat */
  apply(cat) {
    let shown = 0;
    for (const card of $$('[data-cats]', this)) {
      const show = cat === 'all' || (card.dataset.cats ?? '').split(' ').includes(cat);
      card.hidden = !show;
      if (show) shown++;
    }
    for (const chip of $$('[data-filter]', this)) chip.toggleAttribute('aria-current', chip.dataset.filter === cat);
    $('[data-filter][aria-current]', this)?.setAttribute('aria-current', 'page');
    const count = $('[data-filter-count]', this);
    if (count) count.textContent = tpl(shown === 1 ? config.strings.productCount : config.strings.productsCount, { count: shown });
  }
}

if (!customElements.get('collection-grid')) customElements.define('collection-grid', CollectionGrid);
